import React from 'react';
import { Header } from '../components/Header';
import { HeroSection } from '../components/HeroSection';
import { AboutSection } from '../components/AboutSection';
import { AchievementsSection } from '../components/AchievementsSection';
import { OfferSection } from '../components/OfferSection';
import { Footer } from '../components/Footer';
export function HomePage() {
  return <main className="min-h-screen w-full bg-black text-white selection:bg-white selection:text-black" data-id="element-119">
      <Header data-id="element-120" />
      <HeroSection data-id="element-121" />
      <AboutSection data-id="element-122" />
      <AchievementsSection data-id="element-123" />
      <OfferSection data-id="element-124" />
      <Footer data-id="element-125" />
    </main>;
}